import Api from './api.js';
import axios from 'axios';

export class ProductTypeApi extends Api {
    constructor(options = {}) {
        super(options);

        this.apiPath = 'tipoprodutos';
    }

    async getProductTypesList(){
        return await this.axiosInstance.request({
            method: 'get',
            url: this.apiPath,
        });
    }
}
